export default __webpack_public_path__ + "static/media/stake-active.a62b7bf0.svg";